export enum SectionStyle {
    Tabbed = 1,
    Carousel = 2,
    Tiled = 3,
    Column = 4,
}